import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  Skeleton,
} from '@mui/material';

/**
 * TicketsListSkeleton - Loading placeholder for ticket list
 *
 * Displays 3 skeleton items mimicking the TicketListItem layout
 * with circular avatar and text placeholders.
 *
 * Based on ticketz/whaticket TicketsListSkeleton pattern.
 */
export function TicketsListSkeleton() {
  return (
    <>
      <ListItem dense>
        <ListItemAvatar>
          <Skeleton animation="wave" variant="circular" width={40} height={40} />
        </ListItemAvatar>
        <ListItemText
          primary={<Skeleton animation="wave" height={20} width={60} />}
          secondary={<Skeleton animation="wave" height={20} width={90} />}
        />
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem dense>
        <ListItemAvatar>
          <Skeleton animation="wave" variant="circular" width={40} height={40} />
        </ListItemAvatar>
        <ListItemText
          primary={<Skeleton animation="wave" height={20} width={70} />}
          secondary={<Skeleton animation="wave" height={20} width={120} />}
        />
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem dense>
        <ListItemAvatar>
          <Skeleton animation="wave" variant="circular" width={40} height={40} />
        </ListItemAvatar>
        <ListItemText
          primary={<Skeleton animation="wave" height={20} width={60} />}
          secondary={<Skeleton animation="wave" height={20} width={90} />}
        />
      </ListItem>
      <Divider variant="inset" component="li" />
    </>
  );
}

export default TicketsListSkeleton;
